// extracted by mini-css-extract-plugin
export default {"message":"MyReviews_message__9vr3-"};